const isNonEmptySocialValue = value =>
  value != null && String(value).trim() !== '';

/** Drop empty social usernames so the contacts table can show `---` consistently. */
export const normalizeSocialProfiles = value => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
  return Object.fromEntries(
    Object.entries(value).filter(([, profileValue]) =>
      isNonEmptySocialValue(profileValue)
    )
  );
};

export const hasVisibleSocialProfiles = profiles => {
  if (!profiles || typeof profiles !== 'object') return false;
  return Object.values(profiles).some(isNonEmptySocialValue);
};
